'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = prepareTopics;
var SELECTOR_START = '#>';
var TOPICS_SPLITTER = '////>';

var chunk = function chunk(array, maxLength) {
    var result = array.reduce(function (reduced, item, index) {
        var nextLength = reduced.length + item.length;
        if (nextLength > maxLength) {
            var start = reduced.chunkStart;
            var end = index;
            return {
                length: item.length + TOPICS_SPLITTER.length,
                chunkStart: end,
                chunkIndex: reduced.chunkIndex.concat([{
                    start: start,
                    end: end
                }])
            };
        }
        return Object.assign({}, reduced, {
            length: nextLength + TOPICS_SPLITTER.length
        });
    }, {
        length: SELECTOR_START.length,
        chunkStart: 0,
        chunkIndex: []
    });
    var resultChunks = result.chunkIndex.map(function (index) {
        return array.slice(index.start, index.end);
    });
    resultChunks.push(array.slice(result.chunkStart));
    return resultChunks;
};
function prepareTopics(topics, maxLength) {
    return chunk(topics, maxLength).map(function (topicsChunk) {
        return '' + SELECTOR_START + topicsChunk.join(TOPICS_SPLITTER);
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/utils/prepareSelectorSets.js
// module id = 2153
// module chunks = 1